import React, { useState } from 'react';
import { CCol, CRow, CTabs, CNav, CNavItem, CNavLink, CBadge, CTooltip } from '@coreui/react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import { useParams } from 'react-router-dom';
import './ProjectDetails.css';
import Loading from '../aimhi-widgets/Loading';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import DailyReports from './DailyReports';
import Swa from './Swa';
import SiteVisit from './SiteVisit';
import Weekly from './Weekly';
import Timeline from './Timeline';
import TwoWeeks from './TwoWeeks';
import HistoricalReports from './HistoricalReports';
import ProjectTabs from '../projects/ProjectTabs';
import { trackEvent } from 'src/utils/mixpanel';
const Report = () => {
  const { id: projectID } = useParams();
  const [active, setActive] = useState(1);
  const tabWarnings = useSelector((state) => state.project.tabWarnings[projectID]);
  const [loading, setLoading] = useState(false);

  const handleTabNavigate = (idx, name) => {
    setActive(idx)

    trackEvent(`Click to Report - ${name}`, {
      'Source': 'Project - Report',
      'AIMHI Version': 1,
    })
  }

  return (
    <>
      {loading ? <Loading /> : ''}
      <ProjectTabs />
      <CRow>
        <CCol xs="12" sm="12" md="12" lg="12" xl="10" style={{ marginTop: '20px' }}>
          <CTabs>
            <CNav variant="tabs" className="!border-b-[6px]">
              <CNavItem>
                <CNavLink className={active === 1 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(1, "Daily")}>
                  Daily
                </CNavLink>
              </CNavItem>

              <CNavItem>
                <CNavLink className={active === 2 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(2, "Current Week")}>
                  Weekly Progress
                </CNavLink>
              </CNavItem>

              <CNavItem>
                <CNavLink className={active === 7 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(7, "Historical Report")} style={{ position: 'relative' }}>
                  Historical Progress
                  {tabWarnings?.historical_report > 0 && (
                    <CTooltip content={`There ${tabWarnings?.historical_report > 1 ? 'are' : 'is'} ${tabWarnings?.historical_report} missing Historical Reports. Please input the missing Historical Report`} placement="right-end" color="white">
                      <CBadge
                        color="aimhi-danger"
                        style={{
                          position: 'absolute',
                          top: '-5px',
                          right: '-2px',
                          padding: '0.4em',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '50%',
                          width: '20px', // Set a fixed width
                          height: '20px',
                        }}
                      >
                        {tabWarnings?.historical_report}
                      </CBadge>
                    </CTooltip>
                  )}
                </CNavLink>
              </CNavItem>

              <CNavItem>
                <CNavLink className={active === 3 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(3, "Two Weeks Ahead")}>
                  Two Weeks Ahead
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className={active === 4 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(4, "SWA")}>
                  SWA
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className={active === 5 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(5, "Site Visit")}>
                  Site Visit
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink className={active === 6 ? 'nav-design-active' : 'nav-design'} onClick={() => handleTabNavigate(6, "Upload History")}>
                  Upload History
                </CNavLink>
              </CNavItem>
            </CNav>
            {active == 1 && <DailyReports id={projectID} />}
            {active == 2 && <Weekly id={projectID} />}
            {active == 3 && <TwoWeeks id={projectID} />}
            {active == 4 && <Swa id={projectID} />}
            {active == 5 && <SiteVisit id={projectID} />}
            {active == 6 && <Timeline project_id={projectID} />}
            {active == 7 && <HistoricalReports id={projectID} />}
          </CTabs>
        </CCol>
      </CRow>
    </>
  );
};

export default Report;
